export default {
    impuestosArray: [],
    impuestoProductosDefecto: {
        id: 'OyvD8qCoFiFJQjdCMLiY',
        impuesto: "0.1",
        nombre: "IVA 10"
    }
}